export default {
  welcome: 'Welcome to the tutorial',
}
